import { useMemo } from 'react'
import { t } from '@lingui/macro'
import { useGetEstablishmentConsultationsStatisticsQuery } from '@/core/services/statistics'
import { Category } from '@/core/api/statistics'
import CountByStringComponent from './CountByStringComponent'
import { ChartSkeleton } from '@/features/statistics'

function translateStatus(label: string): string {
  switch (label) {
    case 'scheduled':
      return t`Scheduled`
    case 'accepted':
      return t`Accepted`
    case 'refused':
      return t`Refused`
    case 'active':
      return t`Active`
    case 'canceled':
      return t`Canceled`
    case 'completed':
      return t`Completed`
    default:
      return label
  }
}

type ConsultationStatusesProps = {
  establishmentId: string
}

export function ConsultationStatuses({ establishmentId }: ConsultationStatusesProps) {
  const { data, isLoading } = useGetEstablishmentConsultationsStatisticsQuery({
    category: [Category.status],
    establishment: establishmentId,
  })

  const chart = useMemo(() => {
    return {
      labels: data?.category?.[Category.status]?.chart.labels.map((label) => translateStatus(label)) ?? [],
      datasets: data?.category?.[Category.status]?.chart.datasets ?? [],
    }
  }, [data])

  if (isLoading) return <ChartSkeleton />

  return <CountByStringComponent chartData={chart} title={t`Consultations by Status`} />
}
